export const footerTranslations = {
    en: {
        navigation: 'Navigation',
        legal: 'Legal',
        followUs: 'Follow Us',
        links: {
            home: 'Home',
            about: 'About Us',
            services: 'Services',
            appFeatures: 'App Features',
            resources: 'Resources',
            contact: 'Contact',
        },
        legalLinks: {
            terms: 'Terms & Conditions',
            privacy: 'Privacy Policy',
            hipaa: 'HIPAA Waiver',
        },
    },
    es: {
        navigation: 'Navegación',
        legal: 'Legal',
        followUs: 'Síguenos',
        links: {
            home: 'Inicio',
            about: 'Nosotros',
            services: 'Servicios',
            appFeatures: 'Funciones de la App',
            resources: 'Recursos',
            contact: 'Contacto',
        },
        legalLinks: {
            terms: 'Términos y Condiciones',
            privacy: 'Política de Privacidad',
            hipaa: 'Exención de HIPAA',
        },
    },
    tl: {
        navigation: 'Nabigasyon',
        legal: 'Legal',
        followUs: 'Sundan Kami',
        links: {
            home: 'Home',
            about: 'Tungkol sa Amin',
            services: 'Mga Serbisyo',
            appFeatures: 'Mga Feature ng App',
            resources: 'Mga Mapagkukunan',
            contact: 'Makipag-ugnayan',
        },
        legalLinks: {
            terms: 'Mga Tuntunin at Kundisyon',
            privacy: 'Patakaran sa Privacy',
            hipaa: 'HIPAA Waiver',
        },
    },
};